export const getVariantId = (product, size) => {
  if (product.toLowerCase() === "groom box") {
    if (size.toLowerCase() === "s") return "41680716103840";
    if (size.toLowerCase() === "m") return "41680715808928";
    if (size.toLowerCase() === "l") return "41680715415712";
    if (size.toLowerCase() === "xl") return "41680716529824";
    if (size.toLowerCase() === "2xl") return "41680713810080";
    if (size.toLowerCase() === "3xl") return "42525326246048";
  }
};

export const getYears = () => {
  const year = new Date().getFullYear();
  return [
    { value: year, label: year },
    { value: year + 1, label: year + 1 },
    { value: year + 2, label: year + 2 },
    { value: year + 3, label: year + 3 },
    { value: year + 4, label: year + 4 },
  ];
};

export const getMonths = () => {
  return [
    { value: 1, label: "January", short:"Jan" },
    { value: 2, label: "February", short:"Feb"  },
    { value: 3, label: "March", short:"Mar"  },
    { value: 4, label: "April", short:"Apr"  },
    { value: 5, label: "May", short:"May"  },
    { value: 6, label: "June", short:"Jun"  },
    { value: 7, label: "July", short:"Jul"  },
    { value: 8, label: "August", short:"Aug"  },
    { value: 9, label: "September", short:"Sep"  },
    { value: 10, label: "October", short:"Oct"  },
    { value: 11, label: "November", short:"Nov"  },
    { value: 12, label: "December", short:"Dec"  },
  ];
};

export const getDays = (maxLength = 31) => {
    var startDate = 1;
    var returnArr = [];
    for (let index = 0; index < maxLength; index++) {
        returnArr.push({value:startDate, label:startDate});
        startDate++;
    }
    return returnArr;
  };